'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { CLASSNAME_FULL_WIDTH } from '@s7/base';
import { Affix } from '@s7/layout';
import { useProps, packSX } from '@s7/styles';
import { TabNavigation } from '@s7/ui';
import { AnalyticsProvider } from './analytics.js';
import { IDENT, defaultProps } from './TabNavigationWidget.contract.js';
import { TabNavigationWidgetItem } from './TabNavigationWidgetItem.js';
import { containerStyles } from './TabNavigationWidget.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const TabNavigationWidget = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useProps = useProps(IDENT, props, defaultProps), [{ zIndex, sx, analytics, value, data, affixProps }] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "zIndex",
        "sx",
        "analytics",
        "value",
        "data",
        "affixProps"
    ]);
    return /*#__PURE__*/ jsx(AnalyticsProvider, {
        analytics: analytics,
        children: /*#__PURE__*/ jsx(Affix, _extends({
            ref: ref,
            position: {
                bottom: 0,
                right: 0
            },
            withinPortal: false
        }, affixProps, {
            sx: [
                containerStyles,
                {
                    zIndex
                },
                ...packSX(affixProps == null ? void 0 : affixProps.sx)
            ],
            children: /*#__PURE__*/ jsx(TabNavigation, _extends({
                className: CLASSNAME_FULL_WIDTH,
                sx: packSX(sx),
                value: value
            }, others, {
                children: data == null ? void 0 : data.map((tab)=>/*#__PURE__*/ jsx(TabNavigationWidgetItem, _extends({
                        activeTab: value
                    }, tab), tab.value))
            }))
        }))
    });
});
TabNavigationWidget.displayName = IDENT;

export { TabNavigationWidget, TabNavigationWidget as default };
//# sourceMappingURL=TabNavigationWidget.js.map
